class MessageController {
    
    constructor(messageService) {
        this.messageService = messageService;
    }
}

MessageController.$inject = [ 'messageService' ];

export default MessageController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/controllers/message.controller.js